module.exports = __webpack_public_path__ + "static/media/toto_thumb.130aa58c.webp";